export class ValidaRda {

    declaracaoRda: string;
    dadosGeraisEmpresa: string;
    faturamentoProduto: string;
    faturamentoBruto: string;
    projetoProprio: string;
    projetoConveniado: string;
    rdaAlterado: string;


  constructor(init?: Partial<ValidaRda>) {
    Object.assign(this, init);
  }

}
